var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern52)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern52",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4107_9056",
    transform: "scale(0.0322581)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4107_9056",
    width: 31,
    height: 31,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAH6ADAAQAAAABAAAAHwAAAABwh9X2AAAB80lEQVRIDeWWzStFQRiHD1kS2bAgd2GBklssxEbK1ldW7CyULCgLNv4MG2tli3xsbeUjdiIpFkJEWPl8fjlT03Suc++dc7Lw1nPfmTMz7++dmXPnTBCkax2E34Q7+IJt6IPUbRSFT5Coy1Sa6oMEf48QtZPIlqaUgUTibCKuQ6Ht0wzIhIMG8L/Nfjfsl4ibJ4pmfAUZkPXDG9jLbcpb6pCEzRHEBJW/hAzIcu3/7E+z36+C2MKmbCcwRB97Cx6ol/vJBsFMDmGTQNQWPDOmPQ3hZYIeOgldUK8PxYbxXWG5aDfJSDM741d4VgLVcOq0K4E68LbfhBW8Bs7BJCVvLz/V4uzPhMfJ156NymapNZWoGV/zPKNGH5Ow+5HIR7jRR1Rj/5/wWBFLfcsY76WW8AfYL1jcHku4Cbzsz4RHSLvQGd8zxnvGEra/PPn8jyXcCl6mg9+d8TrPdFbLauEM7HcgEWEF103TDqzyIzRD1MmVmDDxg0VwxVW/gROn7Yl6FrzNLOsRkdryiCbhXtA3uxBTspXOgGOJV4CWuNRpdKtRwgraAPJVoccFPfqJsbUyOnRCvsK6e+l63BMiwWKtSuJx15oX+ujgWYBBSMwk3m1F02dTV6B9OAh9C34DEjft+RJIcA8k+gq2rVLxWV47ll3e+QZAjAG9zwhxoQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeName);
export default __webpack_public_path__ + "static/media/change-name.127651ac27bf66a540ce4fb3547d7ecb.svg";
export { ForwardRef as ReactComponent };